import { createContext } from 'react';
import { AuthState } from '@/types/auth';

export interface AuthContextType extends AuthState {
  signIn: (email: string, password: string) => Promise<boolean>;
  signUp: (email: string, password: string, firstName: string, lastName: string) => Promise<boolean>;
  signOut: () => Promise<void>;
  login: (firstName: string, isAdmin: boolean) => void;
  logout: () => Promise<void>;
  getAccessToken: () => Promise<string | null>;
  updateProfile: (input: {
    firstName?: string;
    lastName?: string;
    phone: string;
    birthDate?: string | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    city?: string | null;
    avatarUrl?: string | null;
  }) => Promise<{ success: boolean; error?: string }>;
}

export const AuthContext = createContext<AuthContextType | null>(null);
